import classNames from 'classnames';
import React, { useContext } from 'react';

import { Anchor } from '@zooplus/ui-components';

import AppContext from '../../context';
import { FlyoutTypeEnum, UiCategory } from '../../types';
import { isSpecialLink, resolveBannerItem } from '../../utils/categoryUtils';
import { LinkTypeEnum } from '../Link/Link';

import styles from './CategoryFlyout.module.scss';
import { FlyoutBanner } from './FlyoutBanner';

interface SpecialOffersFlyoutProps {
    category: UiCategory;
    isFlyoutOpen?: boolean;
}

const SpecialOffersFlyout = ({
    category,
    isFlyoutOpen,
}: SpecialOffersFlyoutProps): React.JSX.Element => {
    const { title, path, children, specials, type, animalType } = category;
    const { translations, banner } = useContext(AppContext);
    const viewAllLabel = translations.get('shop.header.categories.title.link');

    const bannerItem = resolveBannerItem(
        category,
        FlyoutTypeEnum.SPECIALS,
        banner,
    );

    return (
        <div className={classNames(styles.animalflyout, styles.scrollBox)}>
            <div className={styles.animalPanelWithBanner}>
                <div className={styles.animalPanelContentWrapper}>
                    <div className={styles.flyOutHeader}>
                        <Anchor
                            href={path}
                            data-link-type={LinkTypeEnum.PRIMARY}
                            data-zta="category-flyout-specialOffers-level2-link">
                            {viewAllLabel} {title}
                        </Anchor>
                    </div>
                    <div className={classNames(styles.animalPanel)}>
                        <ul
                            className={styles.animalPanelGroup}
                            id="header-category-flyout-specialOffer-level3-links">
                            {children?.map((item) => {
                                return (
                                    <li
                                        key={item.title}
                                        className={styles.groupLargeItem}>
                                        <Anchor
                                            variant={
                                                item.highlighted
                                                    ? 'danger'
                                                    : LinkTypeEnum.NEUTRAL
                                            }
                                            data-link-type={
                                                item.highlighted
                                                    ? LinkTypeEnum.OFFER
                                                    : LinkTypeEnum.NEUTRAL
                                            }
                                            className={styles.specialsText}
                                            data-zta="category-flyout-specialOffer-level3-link"
                                            href={item.path}>
                                            {item.title}
                                        </Anchor>
                                    </li>
                                );
                            })}
                        </ul>
                        <ul
                            className={styles.animalPanelGroup}
                            id="header-category-flyout-specialOffer-offer-link">
                            {specials?.map((item) => {
                                const isSpecial = isSpecialLink(item);
                                return (
                                    <li
                                        key={item.path}
                                        className={styles.groupLargeItem}>
                                        <Anchor
                                            variant={
                                                isSpecial
                                                    ? 'danger'
                                                    : LinkTypeEnum.NEUTRAL
                                            }
                                            data-link-type={
                                                isSpecial
                                                    ? LinkTypeEnum.OFFER
                                                    : LinkTypeEnum.NEUTRAL
                                            }
                                            className={classNames({
                                                [styles.nonBoldSpecialsText]:
                                                    isSpecial,
                                            })}
                                            data-zta="category-flyout-specialOffer-offer-link"
                                            href={item.path}>
                                            {item.title}
                                        </Anchor>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className={styles.specialsAndBannerColumn}>
                    <FlyoutBanner
                        banner={bannerItem}
                        categoryType={type}
                        animalType={animalType}
                        isFlyoutOpen={isFlyoutOpen}
                    />
                </div>
            </div>
        </div>
    );
};

export default SpecialOffersFlyout;
